<template lang="pug">
.py-5.text-white.bg-dark
  h2.text-center.text-white Application and Cases
  .pt-4.overflow-hidden
    section.application.d-block.d-sm-none
      .list.text-center(
        v-for="(application, index) in applicationList",
        v-if="application.thumbnail",
        :key="index",
        :style="{ backgroundImage: 'url(' + application.thumbnail.image + ')' }"
      )
        h3.text-white {{ application.title }}
        p {{ application.subtitle }}
        a.more.text-center(
          style="cursor: pointer",
          @click="detailClick(application)"
        )
          | details
          font-awesome-icon.ml-1(:icon="['fas', 'sort-down']")
    section.application.slider
      swiper.swiper-container(:options="swiperOption", ref="mySwiper")
        swiper-slide.swiper-slide.list.text-center(
          v-for="(application, index) in applicationList",
          v-if="application.thumbnail",
          :key="index",
          :style="{ backgroundImage: 'url(' + application.thumbnail.image + ')' }"
        )
          h3.text-white {{ application.title }}
          p {{ application.subtitle }}
          a.more.text-center(
            style="cursor: pointer",
            @click="detailClick(application)"
          )
            | details
            font-awesome-icon.ml-1(:icon="['fas', 'sort-down']") 
      .swiper_bg_arrow
        .swiper-prev.g_bg(v-if="prevBtnShow", @click="prevClick")
          font-awesome-icon(:icon="['fas', 'chevron-left']") 
        .swiper-next.g_bg(v-if="nextBtnShow", @click="nextClick")
          font-awesome-icon(:icon="['fas', 'chevron-right']") 
</template>

<script>
import { getApplication } from "@/api/application";

export default {
  name: "ApplicationAndCases",
  data() {
    var self = this;

    //初始slider可見個數
    let views;

    if (document.body.clientWidth < 600) {
      views = 2;
    } else if (document.body.clientWidth < 1024) {
      views = 3;
    } else {
      views = 4;
    }

    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: views,
        spaceBetween: 30,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        on: {
          resize: function () {
            self.updateSliders();
            this.update();
          },
          slideChangeTransitionEnd: function (data) {
            if (
              data.activeIndex <
              self.applicationList.length - self.swiperOption.slidesPerView
            ) {
              self.nextBtnShow = true;
            } else {
              self.nextBtnShow = false;
            }
            if (data.activeIndex > 0) {
              self.prevBtnShow = true;
            } else {
              self.prevBtnShow = false;
            }
          },
        },
      },
      applicationList: [],
      prevBtnShow: false,
      nextBtnShow: true,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  watch: {
    "$store.state.user.language"() {
      this.initialLanguage();
    },
  },
  created() {
    this.initialLanguage();
  },
  methods: {
    initialLanguage() {
      this.getApplication();
    },
    initPrevNext() {
      if (this.applicationList.length <= this.swiperOption.slidesPerView) {
        this.prevBtnShow = false;
        this.nextBtnShow = false;
      } else {
        this.prevBtnShow = false;
        this.nextBtnShow = true;
      }
    },
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    updateSliders() {
      if (document.body.clientWidth < 600) {
        this.swiper.params.slidesPerView = 2;
        this.swiperOption.slidesPerView = 2;
      } else if (document.body.clientWidth < 1024) {
        this.swiper.params.slidesPerView = 3;
        this.swiperOption.slidesPerView = 3;
      } else {
        this.swiper.params.slidesPerView = 4;
        this.swiperOption.slidesPerView = 4;
      }
      this.initPrevNext();
    },
    getApplication() {
      let temp = {
        lang: this.$store.state.user.language,
      };
      getApplication(temp).then((response) => {
        this.applicationList = response.data;
        this.initPrevNext();
      });
    },
    detailClick(application) {
      this.$router.push({
        name: "Application",
        params: {
          tab_id: application.id,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/home/application_and_cases";
</style>
